import {
  CancelAgencyUploadedFileParams,
  GetImportEmployeeByIdResponse,
  GetImportTimesheetByIdResponse,
  ImportAgencyParams,
  ImportAgencyResponse,
  ImportEmployeeParams,
  ImportEmployeeResponse,
  ImportProspectParams,
  ImportProspectResponse,
  ImportTimesheetParams,
  ImportTimesheetResponse,
  ImportXMLEmployeeParams,
  ImportXMLEmployeeResponse,
  SaveImportAgencyByIdResponse,
  SaveImportProspectByIdResponse,
  SaveImportTimesheetByIdParams,
  SaveImportTimesheetByIdResponse,
  SaveImportXMLEmployeeParams,
  SaveImportXMLEmployeeResponse,
  ValidateImportTimesheetParams,
  ValidateImportTimesheetResponse,
  ValidateImportXMLEmployeeParams,
  ValidateImportXMLEmployeeResponse,
} from '@nxsys/types/api/import';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const importAgencyApi = async (
  params: ImportAgencyParams,
): Promise<ImportAgencyResponse> => {
  const response = await axios.post(endPoints.import.agency, params);
  return response.data;
};

export const saveImportAgencyByIdApi = async (
  id: string,
): Promise<SaveImportAgencyByIdResponse> => {
  const response = await axios.put(`${endPoints.import.saveAgency}/${id}`);
  return response.data;
};

export const getImportEmployeeByIdApi = async (
  id: string,
): Promise<GetImportEmployeeByIdResponse> => {
  const response = await axios.get(`${endPoints.import.getSub}/${id}`);
  return response.data;
};

export const importEmployeeApi = async (
  params: ImportEmployeeParams,
): Promise<ImportEmployeeResponse> => {
  const response = await axios.post(endPoints.import.subcontractor, params);
  return response.data;
};

export const importEmployeeEmployerApi = async (
  params: ImportEmployeeParams,
): Promise<ImportEmployeeResponse> => {
  const response = await axios.post(
    endPoints.import.subcontractorEmployer,
    params,
  );
  return response.data;
};

export const saveImportEmployeeByIdApi = async (
  id: string,
): Promise<SaveImportAgencyByIdResponse> => {
  const response = await axios.put(`${endPoints.import.saveImportSub}/${id}`);
  return response.data;
};

export const importProspectApi = async (
  params: ImportProspectParams,
): Promise<ImportProspectResponse> => {
  const response = await axios.post(endPoints.import.prospect, params);
  return response.data;
};

export const saveImportProspectByIdApi = async (
  id: string,
): Promise<SaveImportProspectByIdResponse> => {
  const response = await axios.put(`${endPoints.import.saveProspect}/${id}`);
  return response.data;
};

export const importTimesheetApi = async (
  params: ImportTimesheetParams,
): Promise<ImportTimesheetResponse> => {
  const response = await axios.post(endPoints.import.timeSheet, params);
  return response.data;
};

export const importTimesheetBureauApi = async (
  params: ImportTimesheetParams,
): Promise<ImportTimesheetResponse> => {
  const response = await axios.post(endPoints.import.timeSheetBureau, params);
  return response.data;
};

export const getImportTimesheetByIdApi = async (
  id: string,
): Promise<GetImportTimesheetByIdResponse> => {
  const response = await axios.get(`${endPoints.import.getTimeSheet}/${id}`);
  return response.data;
};

export const saveImportTimesheetByIdApi = async (
  params: SaveImportTimesheetByIdParams,
  id: string,
): Promise<SaveImportTimesheetByIdResponse> => {
  const response = await axios.put(
    `${endPoints.import.saveTimeSheet}/${id}`,
    params,
  );
  return response.data;
};

// NX-5594: Re-validate timesheet after employer disambiguation.
// Uses PUT /excel/timesheet-mapping-file/:id (MappedFileDto) — same endpoint the
// mapping-file flow uses, which re-parses data, re-persists subcontractorRef, and
// recomputes isCorrectAllRecords. Does NOT use validate-with-mapping-template (requires
// mappingTemplateId which is null in the standard non-template upload flow).
export const validateImportTimesheetApi = async (
  params: ValidateImportTimesheetParams,
): Promise<ValidateImportTimesheetResponse> => {
  const { id, headerCompare, isBureau, employerSelections } = params;
  const response = await axios.put(
    `${endPoints.import.mappingTimeSheet}/${id}`,
    { headerCompare, isBureau, employerSelections },
  );
  return response.data;
};

export const cancelAgencyUploadedFileApi = async (
  id: number,
  params: CancelAgencyUploadedFileParams,
): Promise<{ success: boolean }> => {
  const response = await axios.put(
    `${endPoints.import.agencyUpload}/${id}/cancel`,
    params,
  );
  return response.data;
};

export const importXMLEmployeeApi = async (
  params: ImportXMLEmployeeParams,
): Promise<ImportXMLEmployeeResponse> => {
  const response = await axios.post(endPoints.import.xmlSubcontractor, params);
  return response.data;
};

export const validateImportXMLEmployeeApi = async (
  params: ValidateImportXMLEmployeeParams,
): Promise<ValidateImportXMLEmployeeResponse> => {
  const response = await axios.post(
    endPoints.import.validateXMLSubcontractor,
    params,
  );
  return response.data;
};

export const saveImportXMLEmployeeApi = async (
  params: SaveImportXMLEmployeeParams,
): Promise<SaveImportXMLEmployeeResponse> => {
  const response = await axios.post(
    endPoints.import.saveXMLSubcontractor,
    params,
  );
  return response.data;
};
